import React from 'react'

// const debug = "FieldSelectFields_PickerValueNotEmpty"
const debug = false

export default function FieldSelectFields_PickerValueNotEmpty(props:any) {

    // search for '_PickerValueNotEmpty' for examples...

    debug && console.log(debug, 'render', props)

    const classes = Classes("ui5-field-picker", props.className)

    return (
        <div className={classes} onClick={props.onClick}>
            <div className={Classes("icon", props.field.icon, props.configOptions?.iconClass || props.options?.iconClass)}/>
            {!!props.field.label && <div className="picker-label">{props.field.label}</div>}
            {props.children}
        </div>
    )

}
